export const REQUEST_FORM_MODULE_ID = 'ask-research-request-form-module';

export const LOAD_REQUEST_FORM_MODULE = () =>
  import('@capital-access/ask-research/request-form').then(m => m.AskResearchRequestFormModule);
